import { render, staticRenderFns } from "./MyInvite.vue?vue&type=template&id=1d5d1b34&scoped=true"
import script from "./MyInvite.vue?vue&type=script&lang=js"
export * from "./MyInvite.vue?vue&type=script&lang=js"
import style0 from "./MyInvite.vue?vue&type=style&index=0&id=1d5d1b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5d1b34",
  null
  
)

export default component.exports